// Desktop Sidebar Navigation
// Persistent left-rail counterpart to BottomNavigation, shown at >=1024px.
// Shares navigationItems config with BottomNavigation so both stay in sync.

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  DesktopSidebarContainer,
  SidebarItem,
  SidebarIcon,
  SidebarLabel,
  SidebarSpecialButton,
} from "../../../styles/layout/DesktopSidebar.styles";
import { navigationItems, getActiveNavigationItem, NavigationItemConfig } from "../navigationItems";

interface DesktopSidebarProps {
  isVisible?: boolean;
  onSwipeModeToggle?: (enabled: boolean) => void;
}

export const DesktopSidebar: React.FC<DesktopSidebarProps> = ({
  isVisible = true,
  onSwipeModeToggle,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const activeItem = getActiveNavigationItem(location.pathname);

  const handleClick = (item: NavigationItemConfig) => {
    if (item.isSpecial) {
      onSwipeModeToggle?.(true);
    } else {
      navigate(item.route);
    }
  };

  return (
    <DesktopSidebarContainer $isVisible={isVisible} aria-label="Primary navigation">
      {navigationItems.map((item) => (
        <SidebarItem
          key={item.id}
          $isActive={activeItem === item.id}
          $variant={item.variant}
          onClick={() => handleClick(item)}
          aria-current={activeItem === item.id ? "page" : undefined}
        >
          {item.isSpecial ? (
            <SidebarSpecialButton $isActive={activeItem === item.id}>
              {activeItem === item.id ? item.activeIcon : item.icon}
            </SidebarSpecialButton>
          ) : (
            <>
              <SidebarIcon $isActive={activeItem === item.id}>
                {activeItem === item.id ? (item.activeIcon || item.icon) : item.icon}
              </SidebarIcon>
              <SidebarLabel>{item.label}</SidebarLabel>
            </>
          )}
        </SidebarItem>
      ))}
    </DesktopSidebarContainer>
  );
};
